import { call, put, takeLatest } from 'redux-saga/effects';
import * as api from '../../api';

import * as actionTypes from './action-types';
import * as actions from './actions';

export function* checkUserIsAuthorized() {
    const payload = yield call(api.checkUserIsAuthorised);
    if (payload.status === 200) {
        yield put(actions.checkUserIsAuthorizedSuccess(true));
    } else if (payload.status === 401) {
        yield put(actions.checkUserIsAuthorizedSuccess(false));
    } else {
        yield put(actions.checkUserIsAuthorizedFailure());
    }
}

export function* checkUserIsAuthorizedSaga() {
    yield takeLatest(actionTypes.CHECK_USER_IS_AUTHORIZED_REQUEST, checkUserIsAuthorized);
}



// WEBPACK FOOTER //
// ./app/components/with-auth/saga.js